module.exports = __webpack_public_path__ + "img/natochiy-m.da521e88.jpg";